export default __webpack_public_path__ + "static/media/building.c9d5173f.svg";